export const TKB_SWIFT_REMOVE_CONFIRM = 'tkb-swifts.confirm'
